<template>
  <div class="sub-footer">
    <div class="grid-container fluid">
      <div class="grid-x align-center">
        <div class="cell large-11 medium-10 text-right">
          <router-link :to="nextRoute.path">
            <div class="sub-footer__text-wrapper right">
              <p class="sub-footer__text"
                 data-aos="fade-down"
                 data-aos-offset="0"
                 v-text="getFooterText()">
              </p>
              <div class="sub-footer__arrow-wrapper"
                   data-aos="fade-right"
                   data-aos-duration="400"
                   data-aos-offset="0">
                <img class="sub-footer__arrow sub-footer__arrow_hidden"
                     alt="Continue"
                     src="../../assets/arrow-line.png"
                     style="left: 0px;"/>
                <img class="sub-footer__arrow"
                     alt="Continue"
                     src="../../assets/arrow-line.png"
                     style="left: 400px;"/>
              </div>
            </div>
          </router-link>
          <!-- animated shapes -->
          <div class="shape squares squares--footer">
            <div class="square square--footer"></div>
          </div>
          <div class="shape triangle triangle--footer"></div>
          <div class="shape circle circle--footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheSubFooter',
  props: {
    nextRoute: Object
  },
  methods: {
    getFooterText: function () {
      let footerText = '';
      if (this.nextRoute.index !== 0) footerText = 'Continue to ';
      return footerText + this.nextRoute.name;
    }
  }
};
</script>
